import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import ImageSliderTaille from './carrousseltaille';
import ImageSliderBlanc from './details/bouquets/carrousselblanc';
import ImageSliderMulti from './details/bouquets/carrousselmulticolore';
import ImageSliderOrange from './details/bouquets/carrousselorange';
import ImageSliderRose from './details/bouquets/carrousselrose';
import ImageSliderRouge from './details/bouquets/carrousselrouge';



const Fleuristerie = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
           <div className="col-xs-12 col-md-12">
<br></br>
<br></br>
        <div className="section-title">
          <h2>La fleuristerie artisanale</h2>
            <br></br>
              <br></br>
<br></br>
                  <div className="activites-list">
     <p>
  Chez DELPHIA PAUL, fleuriste à Chennevières-sur-Marne, chaque bouquet est pensé pour refléter vos émotions et sublimer vos moments de vie à travers des compositions florales uniques et artisanales.
  <br /><br />

  Je réalise des bouquets de fleurs fraîches sélectionnées avec soin selon les saisons, vos envies et les événements du quotidien ou exceptionnels.
  <br /><br />

  À l’occasion des fêtes calendaires telles que la Saint-Valentin, la Fête des Mères, le 1er mai, le 14 juillet ou encore les fêtes de fin d’année, je confectionne des bouquets personnalisés pour offrir ou célébrer chaque moment important.
  <br /><br />

  Que ce soit pour une attention romantique, une fête familiale ou une célébration entre proches, chaque création florale est réalisée avec passion afin de transmettre vos émotions avec élégance.
  <br /><br />

  Dans les moments de deuil, je vous accompagne également avec délicatesse en proposant des compositions florales sobres et respectueuses, conçues pour rendre hommage à vos proches disparus.
  <br /><br />

  Tous les bouquets sont disponibles en plusieurs tailles afin de s’adapter à vos envies et à votre budget, avec possibilité de click and collect ou livraison à Chennevières-sur-Marne et dans le Val-de-Marne.
</p>
  <br></br>
      <h3 style={{ color: "#E01174" }}>Les tailles de bouquets :</h3>
<br></br>
           <p style={{ fontSize: "14px" }}><i>* La photo associée à chaque taille est indicative : elle vous permet simplement d’avoir un aperçu du style et du volume correspondant à cette dimension.</i>
</p>  

   <ImageSliderTaille />
        </div>
        <br></br>
     <br></br>
     <br></br>
        <p>Personnalisez votre bouquet ou laissez-vous inspirer par notre collection romantique.
          <br></br>Vous trouverez ci-dessous quelques exemples de mes réalisations.
        </p>
        <br></br>
        <h3>Les nuances de blanc :</h3>
        <p>  Élégants, intemporels et raffinés, mes compositions florales blanches sont idéales pour toutes les occasions : mariage, anniversaire, événement ou simple attention délicate.
</p>
<br></br>
        <ImageSliderBlanc />

       <br></br>
        <h3>Les nuances de rouge :</h3>
        <p>Un bouquet rouge est bien plus qu’un cadeau : c’est une émotion forte, une déclaration sincère réalisée avec des fleurs fraîches et naturelles.</p>
<br></br>
        <ImageSliderRouge />

               <br></br>
        <h3>Les nuances de rose :</h3>
        <p>Des créations florales roses qui expriment la douceur des sentiments et la beauté des petits moments.
</p>
<br></br>
        <ImageSliderRose />

               <br></br>
        <h3>Les nuances orangées :</h3>
        <p> La couleur orange pour des bouquets pleins de vie et de lumière.
</p>
<br></br>
        <ImageSliderOrange />

               <br></br>
        <h3>Les multicolores :</h3>
        <p> Des créations florales colorées, uniques et spontanées, comme un éclat de nature entre vos mains.
</p>
<br></br>
        <ImageSliderMulti />

         
   
      </div>
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
export default Fleuristerie;